import LoginView from "../views/registration/LoginView.vue";
import SignUpView from "../views/registration/SignUpView.vue";
import ActivationView from "../views/registration/ActivationView.vue";
import ResetView from "../views/registration/ResetView.vue";
import NewPasswordView from "../views/registration/NewPasswordView.vue";
import ThankYouView from "../views/registration/ThankYouView.vue";
import InviteView from "@/views/registration/InviteView.vue";

const meta = { noAuth: true };

const loginRoutes = [
  {
    path: "/activation",
    name: "activation",
    component: ActivationView,
    meta
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUpView,
    meta
  },
  {
    path: "/thank-you/:action",
    name: "thank-you",
    component: ThankYouView,
    props: true,
    meta
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetView,
    meta
  },
  {
    path: "/new-password",
    name: "new-password",
    component: NewPasswordView,
    meta
  },
  {
    path: "/create-user/:token",
    props: true,
    name: "create-user",
    component: InviteView,
    meta
  }
];

export default loginRoutes;
